import React from 'react';
import PropTypes from 'prop-types';

import Drawer from 'relements/build/esm/overlays/drawer';
import Icon from 'relements/build/esm/ui/icon';
import Button from 'relements/build/esm/ui/button';

import useVariables from '../../Hooks/useVariables';
import styles from './Variables.scss';

function Variables({ active, onClose, envVariables, hasChanged }) {
  const {
    variable,
    handleNewVariable,
    handleAddVariable,
    handleEditVariable,
    handleDeleteVariable,
  } = useVariables(envVariables, hasChanged);

  return (
    <Drawer
      active={active}
      position="RIGHT"
      width={400}
      zIndex={99999}
      noOverlay
      attachTo="editor-wrapper"
      className={styles.variablesDrawer}
    >
      <div className={styles.variablesDrawerHeader}>
        <h4 className={styles.variablesDrawerHeading}>Variables</h4>
        <div>
          <Icon src="close" onClick={onClose} />
        </div>
      </div>
      <div className={styles.variablesBody}>
        <div className={styles.variablesInputKey}>
          <span>Key</span>
          <input
            type="text"
            placeholder="Example: LEAD_GEN_EMAIL"
            spellCheck={false}
            maxLength={50}
            value={variable.key}
            onChange={handleNewVariable('key')}
          />
        </div>
        <div className={styles.variablesInputStaging}>
          <span>Staging</span>
          <input
            type="text"
            placeholder="Example: test@client.com"
            maxLength={1000}
            spellCheck={false}
            value={variable.staging}
            onChange={handleNewVariable('staging')}
          />
        </div>
        <div className={styles.variablesInputProduction}>
          <span>Production</span>
          <input
            type="text"
            placeholder="Example: reports@client.com"
            maxLength={1000}
            spellCheck={false}
            value={variable.production}
            onChange={handleNewVariable('production')}
          />
        </div>
        <Button
          className={`${styles.buttonDefault} ${styles.saveBtn}`}
          disabled={!variable.key || !variable.staging || !variable.production}
          onClick={handleAddVariable(
            variable.key,
            variable.staging,
            variable.production
          )}
        >
          Add
        </Button>
        <div className={styles.variablesDivision}>
          {envVariables.map((item, i) => {
            return (
              <div className={styles.variablesInput} key={i}>
                <div className={styles.variablesInputKey}>
                  <span>Key</span>
                  <input
                    type="text"
                    placeholder="Write here..."
                    spellCheck={false}
                    maxLength={50}
                    value={item.key}
                    onChange={handleEditVariable(item, i, 'key')}
                  />
                </div>
                <div className={styles.variablesInputStaging}>
                  <span>Staging</span>
                  <input
                    type="text"
                    placeholder="Write here..."
                    spellCheck={false}
                    value={item.staging}
                    maxLength={1000}
                    onChange={handleEditVariable(item, i, 'staging')}
                  />
                </div>
                <div className={styles.variablesInputProduction}>
                  <span>Production</span>
                  <input
                    type="text"
                    placeholder="Write here..."
                    spellCheck={false}
                    maxLength={1000}
                    value={item.production}
                    onChange={handleEditVariable(item, i, 'production')}
                  />
                </div>
                <div
                  className={styles.variablesInputDelete}
                  onClick={handleDeleteVariable(i)}
                >
                  <Icon src="trash" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Drawer>
  );
}

Variables.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  hasChanged: PropTypes.func,
  envVariables: PropTypes.shape([]),
};

Variables.defaultProps = {
  active: false,
  onClose: () => {},
  hasChanged: () => {},
  envVariables: [],
};

export default Variables;
